import { homeVisionSupportingDocTypeOptions } from 'constants/loanActionEditor';

export const HOME_VISION_SUPPORTING_DOCUMENTS_DESCRIPTION =
  'Sent to HomeVision with the order: the newest document of each type on the loan. A type with no document on the loan is skipped.';

export const HOME_VISION_SUPPORTING_DOC_TYPE = {
  key: 'homeVisionDocType',
  label: 'HomeVision document type',
  options: homeVisionSupportingDocTypeOptions,
};
